const $ = require('jquery');
const merrygo = require('merrygo');
const tabn = require('tabn');
const map = require('./map/map');
const slide = require('./slide/slide');
const childNav = require('./childNav/childNav');
const spNav = require('./spNav/spNav');

const isSp = function(){
  return $(window).width() <= 640;
};

$(()=>{
    // mv
    merrygo({
        useArrow: false,
        duration: 500,
        interval: 6000,
        easing: "easeInOutQuad"
    });

    // itemslider
    merrygo({
        root: ".js-merrygo02",
        length: isSp() ? 1 : 4,
        itemMargin: 10,
        duration: 300,
        interval: 4000
    });

    tabn();

    slide();

    spNav();

    map("#google_map", 17,84,100);

    if(!isSp()){
        childNav();
    }
});
